import { useLocation, Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import favoritesIcon from '../../assets/images/solar_star-line-duotone.svg'
import favoritesIconActive from '../../assets/images/solar_star-line-duotone-active.svg'
import './BottomMenu.css'

interface MenuItem {
  path: string
  label: string
  svgIcon?: string
  svgIconActive?: string
  iconifyIcon?: string
}

const menuItems: MenuItem[] = [
  {
    path: '/courses',
    label: 'Курсы',
    iconifyIcon: 'solar:notebook-minimalistic-linear',
  },
  { path: '/', label: 'Главная', iconifyIcon: 'iconoir:home' },
  {
    path: '/favorites',
    label: 'Избранное',
    svgIcon: favoritesIcon,
    svgIconActive: favoritesIconActive,
  },
  { path: '/profile', label: 'Профиль', iconifyIcon: 'solar:user-linear' },
]

const BottomMenu = () => {
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  return (
    <div className="block-bottom-menu">
      <nav className="bottom-menu">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-menu-item ${isActive(item.path) ? 'active' : ''}`}
          >
            {isActive(item.path) && <div className="bottom-menu-indicator" />}
            {item.svgIcon ? (
              <img
                src={
                  isActive(item.path) && item.svgIconActive
                    ? item.svgIconActive
                    : item.svgIcon
                }
                alt={item.label}
                className="bottom-menu-icon"
              />
            ) : item.iconifyIcon ? (
              <Icon icon={item.iconifyIcon} width={32} height={32} />
            ) : null}
            <span className="bottom-menu-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  )
}

export default BottomMenu
